import {NewOperatorRequest, SezioneAvis} from "../../types";
import {BE_BASE_URL} from "../../utils/config";

export const getAllSezioneAvis: () => Promise<string | SezioneAvis[]> = async () => {
    try {
      const response = await fetch(BE_BASE_URL + '/secure/sezione/get-sections', {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const status = response.status;
      if (status === 400) {
        return 'Invalid Account Type';
      }
      if (status !== 401 && status !== 403 && status !== 200) {
        return 'Server Error';
      }
      const res = await response.json();
      if (res) {
        return res as Array<SezioneAvis>
      } else {
        return 'Ko';
      }
    } catch (err: unknown) {
      const errMsg = err as Error;
      return errMsg.message;
    }
};

export const createOperator= async (newOperator: NewOperatorRequest) => {
    try {
      const response = await fetch(BE_BASE_URL + '/admin/create-operator', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(newOperator)
      });
      const status = response.status;
      if (status === 400) {
        return 'Invalid Account Type';
      }
      if (status !== 401 && status !== 403 && status !== 200) {
        return 'Server Error';
      }
      const res = await response.json();
      if (res) {
        console.log(res);
        return 'Ok'
      } else {
        return 'Ko';
      }
    } catch (err: unknown) {
      const errMsg = err as Error;
      return errMsg.message;
    }
};
